import { number, string, object } from "prop-types"
import { Box, StackView } from "@planningcenter/tapestry-react"
import { Loading } from "components/ui"
import useRegistration from "./useRegistration"
import RegisterableContext from "components/admin/registerable/context"
import Errors from "components/admin/registerable/Errors"
import RegistrationContact from "components/admin/registerable/RegistrationContact"
import Actions from "./Actions"
import TransactionsTableWrapper from "./TransactionsTableWrapper"
import EmailActions from "./EmailActions"
import MetaInformation from "./MetaInformation"
import Selections from "./Selections"
import RegistrantQuestions from "./RegistrantQuestions"
import Assignments from "./Assignments"

const Registration = ({ id, paths, restoreAlertText }) => {
  const { loading, errors, registration, setRegistration } = useRegistration(id)

  return (
    <RegisterableContext.Provider
      value={{ registerable: registration, setRegisterable: setRegistration, loading, errors }}
    >
      <Box>
        <Errors />
        {!registration && <Loading />}
        {registration && (
          <>
            <Selections />
            <StackView
              axis="horizontal"
              alignment="start"
              distribution="space-between"
              marginBottom={3}
            >
              <MetaInformation />
              <Actions paths={paths} restoreAlertText={restoreAlertText} />
            </StackView>
            {registration.totalCostMinusDiscounts && (
              <TransactionsTableWrapper
                registrationId={registration.id}
                paths={paths}
                totalDue={registration.totalDue}
                totalRefunds={registration.totalRefunds}
                totalPayments={registration.totalPayments}
                refundDue={registration.refundDue}
              />
            )}
            <RegistrationContact />
            <EmailActions paths={paths} isBalanceDue={!!registration.totalDue} />
            <Box marginTop={3}>{registration.questions.length > 0 && <RegistrantQuestions />}</Box>
            {registration.event.assignmentTypes.length > 0 && <Assignments />}
          </>
        )}
      </Box>
    </RegisterableContext.Provider>
  )
}

Registration.propTypes = {
  id: number.isRequired,
  paths: object.isRequired,
  restoreAlertText: string
}

export default Registration
